import { Navigate } from 'react-router-dom';
import { useGetUserMaybe } from 'v2/core/services/user';
import { Onboarding } from './Onboarding';

export const OnboardingContainer = () => {
  const user = useGetUserMaybe();

  if (user) {
    // If user has already an account
    // redirect them to the home page
    return <Navigate to="/" replace />;
  }

  return <Onboarding />;
};
